/**
 * 세액공제 혜택 계산 (26년 기부금부터 적용)
 * 1. 10만원 이하: 100% 세액공제
 * 2. 10만원 초과 ~ 20만원 이하: 44% 세액공제
 * 3. 20만원 초과: 16.5% 세액공제
 */
export const calculateTaxBenefit = (amount: number): number => {
  if (amount <= 0) return 0;

  // 10만원 이하: 전액 공제
  if (amount <= 100000) {
    return amount;
  }

  // 10만원 초과 ~ 20만원 이하
  if (amount <= 200000) {
    const base = 100000; // 10만원 전액 공제
    const excess = amount - 100000;

    return base + excess * 0.44;
  }

  // 20만원 초과
  const base = 100000; // 10만원 전액 공제
  const middle = 100000 * 0.44; // 10~20만원 구간 44%
  const excess = (amount - 200000) * 0.165; // 20만원 초과분 16.5%

  return base + middle + excess;
};
